import { ReactComponent } from "./schedule-fir-line.svg";

interface Props {
  fill?: string;
  width?: string;
  height?: string;
}

const ScheduleFirLineIcon: React.FC<Props> = (props) => (
  <ReactComponent {...props} />
);

export default ScheduleFirLineIcon;
